import Category from '../pages/category';
import Post from '../pages/post';
import Search from '../pages/search';
import Home from '../pages/home';

const routes = [
    {
        path: "/blog",
        component: Home,
        title: "خانه",
        exact: true
    },
    {
        path: "/blog/category",
        component: Category,
        title: "گروه"
    },
    {
        path: "/blog/:code/:name",
        component: Post,
        title: "جزئیات مقاله"
    },
    {
        path:"/blog/:code",
        component: Post,
        title: "ریدایرکت مقاله",
        exact: true
    },
    {
        path: "/blog/:type/:id/:name",
        component: Search,
        title: "مقاله"
    },
    {
        path: "/blog/search",
        component: Search,
        title: "جستجو"
    },
    {
        path: "/blog/new",
        component: Search,
        title: "جستجو",
        exact: true
    }
];

// const routes = [
//     {
//         path: "/",
//         component: Home,
//         title: "خانه",
//         exact: true
//     },
//     {
//         path: "/category",
//         component: Category,
//         title: "گروه"
//     },
//     {
//         path: "/:code/:name",
//         component: Post,
//         title: "جزئیات مقاله"
//     },
//     {
//         path: "/:code",
//         component: Post,
//         title: "ریدایرکت مقاله",
//         exact: true
//     },
//     {
//         path: "//:type/:id/:name",
//         component: Search,
//         title: "مقاله"
//     },
//     {
//         path: "/search",
//         component: Search,
//         title: "جستجو"
//     },
//     {
//         path: "/new",
//         component: Search,
//         title: "جستجو"
//     }
// ];

export default routes;
